import React from 'react';
import { useNavigate } from 'react-router-dom';
import KillSwitchButton from '@/components/KillSwitchButton';

export default function Topbar({ title, subtitle, right }) {
  return (
    <div className="flex items-center justify-between px-3 sm:px-4 lg:px-6 py-3 border-b border-border bg-background sticky top-0 z-10">
      <div className="min-w-0">
        <h1 className="text-base md:text-lg truncate" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-xs text-muted-foreground truncate">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {right}
        <KillSwitchButton />
      </div>
    </div>
  );
}
